import { call, put, takeLatest } from "redux-saga/effects";
import { callAPI, handleError, handleSuccess } from "../api/api";
import JsFileDownloader from "js-file-downloader";
import { refreshStorageLogList } from "../reducers/storageSlice";

import { setLoaderAction, setNotificationAction } from "../reducers/mmymSlice";

import {
  checkCustomerStorageAction,
  checkServiceForContractAction,
  createContractAction,
  deleteContractAction,
  emailContractAction,
  getContractListAction,
  getSingleContractAction,
  getStorageNotificationAction,
  invoiceGeneratedAction,
  invoiceGenerateForMoveToJob,
  moveToJobFinalAction,
  markStorageNotificationReadAction,
  printContractAction,
  setCheckCustomerStorageResponseAction,
  setCheckServiceForContractResponse,
  setContractListAction,
  setCreateContractResponseAction,
  setDeleteContractResponseAction,
  setEmailContractResponseAction,
  setInvoiceGeneratedForMoveToJobResponse,
  setInvoiceGeneratedResponse,
  setMoveToJobFinalResponse,
  setPrintContractResponseAction,
  setSingleContractAction,
  setStorageNotificationResponse,
  setStorageNotificationReadResponse,
  updateContractAction,
  deleteContractUnitAction,
  setDeleteContractUnitResponse,
  sendContractSignLinkAction,
  getContractSignDetailsAction,
  updateContractSignAction,
  setSendContractSignLinkResponse,
  setContractSignDetailsResponse,
  setUpdateContractSignResponse,
} from "../reducers/contractStorageSlice";

/**
 * This function for call the user profile
 *
 * @param {*} payload
 */

/* -------------------------------------------------------------------------- */
/* API Config                                                                 */
/* -------------------------------------------------------------------------- */

const V2_CONFIG = {
  baseURL: process.env.REACT_APP_BASE_URL_V2,
};

function* getContractListSaga(payload: any): any {
  yield put(setLoaderAction(true));
  const { leadId, page, limit } = payload?.payload;
  try {
    const res = yield call<any>(
      callAPI,
      {},
      "get",
      `storage/leads/${leadId}/contracts?page=${page}&limit=${limit}`,
      "",
      V2_CONFIG,
    );
    if (res?.data) {
      yield put(setContractListAction(res?.data));
    }
  } catch (error) {
    console.log("Catch Error-", error);
  }
  yield put(setLoaderAction(false));
}

function* createContractSaga(payload: any): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  const { leadId, customerName, ...newPayload } = payload?.payload;
  try {
    const apiResponse = yield call<any>(
      callAPI,
      { payload: newPayload },
      "post",
      `storage/leads/${leadId}/contracts`,
      "",
      V2_CONFIG,
    );
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setCreateContractResponseAction(true));
      yield put(refreshStorageLogList());
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setCreateContractResponseAction(false));
  }
  yield put(setLoaderAction(false));
}

function* updateContractSaga(payload: any): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const {
      leadId,
      contractId,
      createdAt,
      updatedAt,
      contractNo,
      id,
      is_final_invoice,
      customerId,
      customer,
      customerName,
      units,
      storageLeadId,
      payment_method,
      inventoryId,
      ...newPayload
    } = payload?.payload;
    const apiResponse = yield call<any>(
      callAPI,
      { payload: newPayload },
      "put",
      `storage/leads/${leadId}/contracts/${contractId}`,
      "",
      V2_CONFIG,
    );
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setCreateContractResponseAction(true));
      yield put(refreshStorageLogList());
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setCreateContractResponseAction(false));
  }
  yield put(setLoaderAction(false));
}



function* checkCustomerStorageSaga(payload: any): any {
  yield put(setLoaderAction(true));
  const { leadId } = payload?.payload;
  try {
    const res = yield call<any>(
      callAPI,
      {},
      "get",
      `/storage/removal-transition/preview?leadId=${leadId}`,
      "",
      V2_CONFIG,
    );

    if (res?.data) {
      yield put(setCheckCustomerStorageResponseAction(res?.data));
    }
  } catch (error) {
    console.log("Catch Error-", error);
  }
  yield put(setLoaderAction(false));
}

function* getSingleContractSaga(payload: any): any {
  yield put(setLoaderAction(true));
  const { id } = payload?.payload;
  try {
    const res = yield call<any>(
      callAPI,
      {},
      "get",
      `storage/contracts/${id}`,
      "",
      V2_CONFIG,
    );

    if (res?.data) {
      yield put(setSingleContractAction(res?.data));
    }
  } catch (error) {
    console.log("Catch Error-", error);
  }
  yield put(setLoaderAction(false));
}

function* invoiceGeneratedSaga(payload: any): any {
  yield put(setLoaderAction(true));
  const { ids, ...newPayload } = payload?.payload;
  try {
    const apiResponse = yield call<any>(
      callAPI,
      { payload: newPayload },
      "post",
      `/account/storage/invoices`,
      "",
      V2_CONFIG,
    );

    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setInvoiceGeneratedResponse(true));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setInvoiceGeneratedResponse(false));
  }

  yield put(setLoaderAction(false));
}

function* deleteContractSaga(payload: any): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  const { contractId } = payload?.payload;
  try {
    const apiResponse = yield call<any>(
      callAPI,
      {},
      "delete",
      `storage/contracts/${contractId}`,
      "",
      V2_CONFIG,
    );
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setDeleteContractResponseAction(true));
      yield put(refreshStorageLogList());
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setDeleteContractResponseAction(false));
  }
  yield put(setLoaderAction(false));
}

function* emailContractSaga(action: any): any {
  yield put(setLoaderAction(true));
  const { contractId, ...newPayload } = action?.payload || {};
  try {
    const apiResponse = yield call<any>(
      callAPI,
      { payload: newPayload },
      "post",
      `storage/contracts/${contractId}/send-email`,
      "",
      V2_CONFIG,
    );
    if (apiResponse?.success === true) {
      handleSuccess(apiResponse);
      yield put(setEmailContractResponseAction(true));
      yield put(refreshStorageLogList());
    }
  } catch (error: any) {
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setEmailContractResponseAction(false));
    console.log("Catch Error-", error);
  }
  yield put(setLoaderAction(false));
}

function* printContractSaga(action: any): any {
  yield put(setLoaderAction(true));
  const { contractId, ...newPayload } = action?.payload || {};
  try {
    const apiResponse = yield call<any>(
      callAPI,
      {payload:newPayload},
      "post",
      `storage/contracts/${contractId}/document`,
      "",
      V2_CONFIG,
    );
    if (apiResponse?.success === true && apiResponse?.data?.pdfUrl) {
      yield call<any>(
        () =>
          new JsFileDownloader({
            url: apiResponse.data.pdfUrl,
            filename: `Contract-${contractId}.pdf`,
          }),
      );
      handleSuccess(apiResponse);
      yield put(setPrintContractResponseAction(true));
      yield put(refreshStorageLogList());
    }
  } catch (error: any) {
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setPrintContractResponseAction(false));
    console.log("Catch Error-", error);
  }
  yield put(setLoaderAction(false));
}

function* invoiceGenerateForMoveToJobSaga(action:any):any{
   yield put(setLoaderAction(true));
  const { contractId, leadId } = action?.payload || {};
   try {
    const apiResponse = yield call<any>(
      callAPI,
      { payload: { contractId, leadId } },
      "post",
      `account/storage/invoices/final`,
      "",
      V2_CONFIG,
    );
    if (apiResponse?.success === true) {
      handleSuccess(apiResponse);
      yield put(setInvoiceGeneratedForMoveToJobResponse(true));
      // yield put(refreshStorageLogList());
    }
  } catch (error: any) {
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setInvoiceGeneratedForMoveToJobResponse(false));
    console.log("Catch Error-", error);
  }
  yield put(setLoaderAction(false));
}

function* checkServiceForContractSaga(action:any):any{
  yield put(setLoaderAction(true));
  const { contractId, leadId } = action?.payload || {};
   try {
    const apiResponse = yield call<any>(
      callAPI,
      {},
      "get",
      `storage/service-check?removalLeadId=${leadId}`,
      "",
      V2_CONFIG,
    );
    if (apiResponse?.success === true) {
      handleSuccess(apiResponse);
      yield put(setCheckServiceForContractResponse(apiResponse?.data));
      // yield put(refreshStorageLogList());
    }
  } catch (error: any) {
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setCheckServiceForContractResponse(null));
    console.log("Catch Error-", error);
  }
  yield put(setLoaderAction(false));
}

function* moveToJobFinalSaga(action:any):any{
  yield put(setLoaderAction(true));
  const { contractId, ...newPayload } = action?.payload || {};
   try {
    const apiResponse = yield call<any>(
      callAPI,
      { payload: newPayload },
      "post",
      `storage/contracts/${contractId}/move-to-job`,
      "",
      V2_CONFIG,
    );
    if (apiResponse?.success === true) {
      handleSuccess(apiResponse);
      yield put(setMoveToJobFinalResponse(true));
    } else {
      handleError(apiResponse);
      yield put(setMoveToJobFinalResponse(false));
    }
  } catch (error: any) {
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setMoveToJobFinalResponse(false));
    console.log("Catch Error-", error);
  }
  yield put(setLoaderAction(false));
}

function* getStorageNotificationSaga(action: any): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const { page = 1, limit = 10 } = action?.payload || {};
    const apiResponse = yield call<any>(
      callAPI,
      {},
      "get",
      `storage/inventories/notifications?page=${page}&limit=${limit}`,
      "",
      V2_CONFIG,
    );

    if (apiResponse?.success === true) {
      // handleSuccess(apiResponse);
      yield put(setStorageNotificationResponse(apiResponse?.data));
    }
  } catch (error: any) {
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
  }
  yield put(setLoaderAction(false));
}

function* markStorageNotificationReadSaga(action: any): any {
  yield put(setLoaderAction(true));
  try {
    const { inventory_id, ...newPayload } = action?.payload || {};
    const apiResponse = yield call<any>(
      callAPI,
      { payload: newPayload },
      "put",
      `storage/inventories/notifications`,
      "",
      V2_CONFIG,
    );

    if (apiResponse?.success === true) {
      handleSuccess(apiResponse);
      yield put(setStorageNotificationReadResponse(inventory_id));
    }
  } catch (error: any) {
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
  }
  yield put(setLoaderAction(false));
}

function* deleteContractUnitSaga(payload: { payload: any }): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const { contractId, unitId } = payload?.payload;
    const apiResponse = yield call<any>(
      callAPI,
      {},
      "delete",
      `storage/contracts/${contractId}/units/${unitId}`,
      "",
      V2_CONFIG,
    );
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setDeleteContractUnitResponse(true));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    error?.response && handleError(error?.response);
     yield put(setDeleteContractUnitResponse(false));
    error?.code === "ERR_NETWORK" && handleError(error);
  } finally {
    yield put(setLoaderAction(false));
  }
}

function* sendContractSignLinkSaga(action:any):any{
  yield put(setLoaderAction(true));
  const { contractId, ...newPayload } = action?.payload || {};
   try {
    const apiResponse = yield call<any>(
      callAPI,
      {},
      "post",
      `storage/contracts/${contractId}/send-sign-link`,
      "",
      V2_CONFIG,
    );
    if (apiResponse?.success === true) {
      handleSuccess(apiResponse);
      yield put(setSendContractSignLinkResponse(true));
    } else {
      handleError(apiResponse);
      yield put(setSendContractSignLinkResponse(false));
    }
  } catch (error: any) {
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setSendContractSignLinkResponse(false));
    console.log("Catch Error-", error);
  }
  yield put(setLoaderAction(false));
}

function* getContractSignDetailsSaga(action:any):any{
  yield put(setLoaderAction(true));
  const { tenantId,contractId,token, ...newPayload } = action?.payload || {};
   try {
    const apiResponse = yield call<any>(
      callAPI,
      {},
      "get",
      `storage/public/contract-sign?tenantId=${tenantId}&contractId=${contractId}&token=${token}`,
      "",
      V2_CONFIG,
    );
    if (apiResponse?.success === true) {
      handleSuccess(apiResponse);
      yield put(setContractSignDetailsResponse(apiResponse?.data));
    } else {
      handleError(apiResponse);
      yield put(setContractSignDetailsResponse(null));
    }
  } catch (error: any) {
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
     yield put(setContractSignDetailsResponse(null));
    console.log("Catch Error-", error);
  }
  yield put(setLoaderAction(false));
}

function* updateContractSignSaga(action:any):any{
  yield put(setLoaderAction(true));
  const { ...newPayload } = action?.payload || {};
   try {
    const apiResponse = yield call<any>(
      callAPI,
      { payload: newPayload },
      "post",
      `storage/public/contract-sign`,
      "",
      V2_CONFIG,
    );
    if (apiResponse?.success === true) {
      handleSuccess(apiResponse);
      yield put(setUpdateContractSignResponse(true));
    } else {
      handleError(apiResponse);
      yield put(setUpdateContractSignResponse(false));
    }
  } catch (error: any) {
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setUpdateContractSignResponse(false));
    console.log("Catch Error-", error);
  }
  yield put(setLoaderAction(false));
}

export function* watchContractStorage() {
  yield takeLatest<any>(getContractListAction, getContractListSaga);
  yield takeLatest<any>(createContractAction, createContractSaga);
  yield takeLatest<any>(updateContractAction, updateContractSaga);
  yield takeLatest<any>(checkCustomerStorageAction, checkCustomerStorageSaga);
  yield takeLatest<any>(getSingleContractAction, getSingleContractSaga);
  yield takeLatest<any>(invoiceGeneratedAction, invoiceGeneratedSaga);
  yield takeLatest<any>(deleteContractAction, deleteContractSaga);
  yield takeLatest<any>(emailContractAction, emailContractSaga);
  yield takeLatest<any>(printContractAction, printContractSaga);
  yield takeLatest<any>(invoiceGenerateForMoveToJob,invoiceGenerateForMoveToJobSaga);
  yield takeLatest<any>(checkServiceForContractAction,checkServiceForContractSaga);
  yield takeLatest<any>(moveToJobFinalAction, moveToJobFinalSaga);
  yield takeLatest<any>(getStorageNotificationAction, getStorageNotificationSaga);
  yield takeLatest<any>(
    markStorageNotificationReadAction,
    markStorageNotificationReadSaga,
  );
  yield takeLatest<any>(deleteContractUnitAction, deleteContractUnitSaga);
  yield takeLatest<any>(sendContractSignLinkAction,sendContractSignLinkSaga);
  yield takeLatest<any>(getContractSignDetailsAction,getContractSignDetailsSaga);
  yield takeLatest<any>(updateContractSignAction,updateContractSignSaga);

}
